<template>
  <form-wrapper
    :inline="inline"
    :label-classes="labelClasses"
    :label="label"
    :error="error"
    :required="required"
  >
    <div :class="{ 'flex flex-wrap': columns }" ref="container">
      <div v-for="(option, index) in options" class="checkbox" :class="getFieldClasses" :key="index">
        <input
          v-model="model"
          type="checkbox"
          :value="getValue(option)"
          :name="getName"
          :id="getId(index)"
          :disabled="disabled"
          @focus="onFocus(option)"
          @blur="onBlur"
        />
        <label :class="getLabelClass" :for="getId(index)">
          <slot :label="getLabel(option)" :checked="isChecked(option)" :focused="isFocused(option)">
            <span class="label-switch" :data-label="getSelectedLabel(option)"></span>
            {{ getLabel(option) }}
          </slot>
        </label>
      </div>
    </div>
    <template #label><slot name="label"></slot></template>
  </form-wrapper>
</template>

<script>
import { resolveValue, isDescendant } from "../../helpers/utils";
import FormWrapper from "./FormWrapper";

export default {
  components: {
    FormWrapper
  },
  model: {
    event: "change"
  },
  props: {
    value: Array,
    label: String,
    name: String,
    labelClasses: [String, Array],
    error: [String, Array],
    columns: {
      type: [Boolean, Number],
      default: false
    },
    valueGetter: {
      type: String,
      default: "value"
    },
    labelGetter: {
      type: String,
      default: "label"
    },
    options: {
      type: Array,
      default: () => []
    },
    labels: {
      type: Array,
      default: () => []
    },
    switch: {
      type: Boolean,
      default: false
    },
    inline: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      focused: null
    };
  },
  computed: {
    getFieldClasses() {
      let fieldClasses = [
        {
          "is-switch": this.switch,
          inline: !this.columns
        }
      ];
      if (this.columns) {
        if (typeof this.columns === 'boolean') {
          fieldClasses.push(`w-full`);
        } else {
          fieldClasses.push(`w-full md:w-1/${this.columns}`);
        }
      }
      return fieldClasses;
    },
    getLabelClass() {
      return {
        "checkbox-label": !this.$slots.default && !this.$scopedSlots.default
      };
    },
    getName() {
      return this.name
        ? `${this.name}-${this._uid}`
        : `${this._uid}`;
    },
    model: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("change", value);
      }
    }
  },
  methods: {
    getValue(option) {
      return typeof option === "string"
        ? option
        : resolveValue(option, this.valueGetter);
    },
    getSelectedLabel(option) {
      return this.model.includes(this.getValue(option)) ? 'Candidat' : 'Employeur'
    },
    getLabel(option) {
      return typeof option === "string"
        ? option
        : resolveValue(option, this.labelGetter);
    },
    getId(index) {
      return this.name
        ? `${this.name}-${this._uid}-${index}`
        : `${this._uid}-${index}`;
    },
    isChecked(option) {
      return this.model ? this.model.includes(this.getValue(option)) : false
    },
    isFocused(option) {
      return this.focused === this.getValue(option);
    },
    onFocus(option) {
      this.focused = this.getValue(option);
    },
    onBlur() {
      this.focused = null;

      // setTimeout(() => {
      //   if (!isDescendant(this.$refs.container, document.activeElement)) {
      //     this.$emit('focusout')
      //   }
      // }, 0)
    }
  }
};
</script>
